module.exports = __webpack_public_path__ + "img/web1.eb50b694.png";